export default __webpack_public_path__ + "static/media/btn-skip-red.3997da19.png";